require('../../node_modules/uikit/dist/js/uikit.min.js')
import UIkit from 'uikit'

//UIkit.slider('.uk-slider', {autoplay:true});
/*$(document).on('click', ".mobile-menu-icon", function ( event ) {
    if($(this).find('input').is(':checked')) {
        $('.menu-container').addClass('open');
    } else {
        $('.menu-container').removeClass('open');
    }
} )*/

$(document).on('click', ".mobile-menu-icon", function ( event ) {
    if($(this).find('input').is(':checked')) {
        $('.mobile-nav-container').addClass('open');
    } else {
        $('.mobile-nav-container').removeClass('open');
    }
} )

/*
$( window ).resize(function() {
    menuClass();
});

function menuClass() {
    if($( window ).width() < 1025) {

        // Hide header on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('header').outerHeight();

        $(window).scroll(function(event){
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(document).scrollTop();


            if(Math.abs(lastScrollTop - st) <= delta)
                return;

            if (st > lastScrollTop && st > navbarHeight ){
                // Scroll Down
                $('header').removeClass('nav-down').addClass('nav-up');
            } else {
                // Scroll Up
                if(st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').addClass('nav-down');
                }
                if (st < 300) {
                    $('header').addClass('hiding');
                }
                if (st < 200) {
                    $('header').removeClass('nav-down').removeClass('hiding');
                }
            }

            lastScrollTop = st;
        }

    }
};

*/

UIkit.scrollspy('.scroll-left-small', {cls:'uk-animation-slide-left-small', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-right-small', {cls:'uk-animation-slide-right-small', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-left-medium', {cls:'uk-animation-slide-left-medium', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-right-medium', {cls:'uk-animation-slide-right-medium', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-fade', {cls:'uk-animation-fade', repeat: true, delay: 100});
UIkit.scrollspy('.scroll-fade1', {cls:'uk-animation-fade', repeat: true, delay: 50});
UIkit.scrollspy('.scroll-fade2', {cls:'uk-animation-fade', repeat: true, delay: 150});
UIkit.scrollspy('.scroll-fade3', {cls:'uk-animation-fade', repeat: true, delay: 250});
UIkit.scrollspy('.scroll-fade4', {cls:'uk-animation-fade', repeat: true, delay: 350});
UIkit.scrollspy('.scroll-fade5', {cls:'uk-animation-fade', repeat: true, delay: 450});
UIkit.scrollspy('.scroll-fade6', {cls:'uk-animation-fade', repeat: true, delay: 550});
UIkit.scrollspy('.scroll-fade-text', {cls:'uk-animation-fade', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-slide-img img', {cls:'uk-animation-slide-right', repeat: true, delay: 200});
UIkit.scrollspy('.scroll-slide-img-left img', {cls:'uk-animation-slide-left', repeat: true, delay: 200});


jQuery(document).on("focus", '.form-group', function () {
    jQuery(this).find("label").addClass('moveUp');
});

jQuery(document).on("blur", '.form-group > input', function () {
    if (jQuery(this).val() === '') {
        jQuery(this).parent('.form-group').find('label').removeClass('moveUp');
    }
});

jQuery(document).on("blur", '.form-group > textarea', function () {
    if (jQuery(this).val() === '') {
        jQuery(this).parent('.form-group').find('label').removeClass('moveUp');
    }
});

jQuery(document).ready(function ($) {
    $(".et-js-tilt").tilt({
        glare: true,
        maxGlare: 0.2,
        perspective: 1500
    });

    $(".uk-button-primary, .uk-button-secondary, .submit, .order-btn, .proceed-button a, .butn-next, .butn-light, .no-products-in-cart .btn ").tilt({
        glare: true,
        maxGlare: 0.3,
        scale: 1.1,
        perspective: 500
    });

});
